import { Sun, Battery, Leaf, LineChart } from 'lucide-react';

interface WelcomeScreenProps {
  onNext: () => void;
}

export function WelcomeScreen({ onNext }: WelcomeScreenProps) {
  return (
    <div className="max-w-6xl mx-auto px-4">
      <div className="text-center mb-8 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6">
          Transform Your Energy Future
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
          Whether you're a homeowner, business, or industrial facility, we'll help you design 
          the perfect energy solution for your needs. Get started in just a few simple steps.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 sm:mb-12">
        <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
          <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
            <Sun className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Upload Your Bill</h3>
          <p className="text-gray-600">
            Share your electricity bill for a personalized analysis
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
          <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
            <Battery className="h-6 w-6 text-green-600" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Design Your System</h3>
          <p className="text-gray-600">
            Get a custom energy design based on your needs
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
          <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
            <LineChart className="h-6 w-6 text-purple-600" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Review Savings</h3>
          <p className="text-gray-600">
            See your potential savings and ROI analysis
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
          <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
            <Leaf className="h-6 w-6 text-amber-600" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Go Green</h3>
          <p className="text-gray-600">
            Start your journey to sustainable energy
          </p>
        </div>
      </div>

      <div className="flex justify-center mb-12">
        <button
          onClick={onNext}
          className="bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 sm:py-4 px-6 sm:px-8 rounded-lg text-lg font-medium hover:from-blue-700 hover:to-green-700 transform transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg"
        >
          Start Your Energy Journey
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mt-8 sm:mt-16">
        <div className="text-center">
          <h4 className="text-xl sm:text-2xl font-bold text-blue-600 mb-2">2M+</h4>
          <p className="text-gray-600">kWh Generated</p>
        </div>
        <div className="text-center">
          <h4 className="text-xl sm:text-2xl font-bold text-green-600 mb-2">1000+</h4>
          <p className="text-gray-600">Happy Customers</p>
        </div>
        <div className="text-center">
          <h4 className="text-xl sm:text-2xl font-bold text-amber-600 mb-2">50K+</h4>
          <p className="text-gray-600">CO₂ Tons Saved</p>
        </div>
      </div>
    </div>
  );
}